let renderTime: number | undefined;
let currentTime: number = 0;

export function startRenderTime(): void {
  renderTime = Date.now();
}

export function incrementCurrentRenderTime(): void {
  currentTime += renderTime ? Date.now() - renderTime : 0;
  renderTime = undefined;
}

export function getCurrentRenderTime(): number {
  incrementCurrentRenderTime();
  startRenderTime();
  return currentTime;
}
